
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useLeagueAdd } from '@/modules/league/model/add';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton },
    setup() {
        const { model, v$, create, timeUnits } = useLeagueAdd();

        return { v$, model, create, timeUnits };
    }
});
